import { forwardRef } from 'react'
import { FormInput, type FormInputProps } from './FormInput'

export interface FormDateInputProps extends Omit<FormInputProps, 'type'> { }

/**
 * A shorthand for FormInput type="date".
 * Automatically handles InputLabelProps shrink for date fields.
 */
export const FormDateInput = forwardRef<HTMLDivElement, FormDateInputProps>(
  (props, ref) => {
    return (
      <FormInput
        {...props}
        ref={ref}
        type="date"
        InputLabelProps={{
          shrink: true,
          ...props.InputLabelProps,
        }}
      />
    )
  }
)

FormDateInput.displayName = 'FormDateInput'
